// Claves públicas Antelope: formato antiguo "EOS" + 50 caracteres base58, o el nuevo
// "PUB_K1_…" / "PUB_R1_…" / "PUB_WA_…" (WebAuth, habitual en XPR). Los nombres de cuenta
// van en minúsculas y nunca empiezan por "EOS" ni "PUB_", así que no se confunden.
const BASE58 = '[1-9A-HJ-NP-Za-km-z]';
const PUBLIC_KEY = new RegExp(`^(EOS${BASE58}{50}|PUB_(K1|R1|WA)_${BASE58}{40,})$`);

export const isPublicKey = (term) => PUBLIC_KEY.test(term);
